import axios from "axios";
import LocalStorage from "../../localStorage";
import {loggedOut} from "../auth";

export const GET_GAO_DESCRIPTION_REQUEST = 'GET_GAO_DESCRIPTION_REQUEST';
export const GET_GAO_DESCRIPTION_SUCCESS = 'GET_GAO_DESCRIPTION_SUCCESS';
export const GET_GAO_DESCRIPTION_FAILURE = 'GET_GAO_DESCRIPTION_FAILURE';

const localStorageService = LocalStorage.getService();

export const getGaoDescriptionRequest = () => {
    return {type: GET_GAO_DESCRIPTION_REQUEST}
};

export const getGaoDescriptionSuccess = (gao_description = {}) => {
    return {type: GET_GAO_DESCRIPTION_SUCCESS, gao_description}
};

export const getGaoDescriptionFailure = (error) => {
    return {type: GET_GAO_DESCRIPTION_FAILURE, error}
};

export const startGetGaoDescription = () => {
    console.log('Start startGetGaoDescription');
    let token = localStorageService.getAccessToken();
    return (dispatch) => {
        dispatch(getGaoDescriptionRequest());
        return axios({
                url: `${process.env.REACT_APP_API_ROOTURL}/gao/list?key=${process.env.REACT_APP_SERVICE_ACCOUNT_KEY}`,
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': '*',
                    Authorization: 'Bearer ' + token,
                },
                data: JSON.stringify({}),
            }
        )
            .then(function (response) {
                if (response.status === 200 && response.data !== null) {
                    console.log("Response gao_description search ", response.data);
                    dispatch(getGaoDescriptionSuccess(response.data));

                }
            })
            .catch(function (error) {
                console.log(error);
                if(error.response.status === 401) dispatch(loggedOut());
                dispatch(getGaoDescriptionFailure(error));
            });
    };
};
